
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Actions from "../../Components/Ui/tables/Actions";
import { useNavigate } from "react-router-dom";
import { useDeleteKey } from "../../api/Key";
import ColumnsImage from "../../Components/Columns/ColumnsImage";
import { FaFile } from "react-icons/fa";
import { ImageBaseURL } from "../../api/config";


const useTableColumns :any = () => {
  const [t] = useTranslation();
  const deleteMutation = useDeleteKey()
  const navigate = useNavigate()
    return useMemo(
    () => [
 
      {
        name: t("id"),
        sortable: true,
        center: true,
        selector: (row: any) => row.id, 
      }, 
      {
        name: t("key"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.key
      },

      {
        name: t("type"),
        sortable: false,
        center: "true",
        cell: (row:any) => row?.type
      },

      {
        name: t("value"),
        sortable: false,
        center: true,
        cell: (row:any) => {

            if (row?.key === "portfolio") {
              let src = row?.value;
              return <a target="_blank" rel="noreferrer" href={ImageBaseURL + src}> <FaFile  /> </a>
                        } else if(row?.value.startsWith("/")){
                          let src = row?.value;
                          return <ColumnsImage src={src} />
                        } else{
                return <div className="single-line-div">{row?.value} </div> ;
            }
        }
    },    
      {
        name: "#",
        sortable: false,
        center: true,
        cell: (row:any) => (
          <Actions
            objectToEdit={row}
            showEdit
            onEdit={()=> navigate(`/key/${row.id}`) }
            showView={false}
            showDelete={false}
            // onDelete={() => deleteMutation.mutate({ id: row.id })}
          >  
          </Actions>
        ),
      },

    ],
    [deleteMutation, navigate, t]
  );
};

export default useTableColumns;

